export const nutritionInfoSchema = {
    displayName: 'nutrition info',
    type: 'object',
    fields: {
        baseCalories: {
            type: 'int',
            displayName: 'Base Calories',
            isNullable: true,
        },
        posBaseCalories: {
            type: 'int',
            displayName: 'POS Base Calories',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default base calories. The field “Base Calories” will replace this number on the kiosk.',
            },
        },
        maxCalories: {
            type: 'int',
            displayName: 'Max Calories',
            isNullable: true,
        },
        posMaxCalories: {
            type: 'int',
            displayName: 'POS Max Calories',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default max calories. The field “Max Calories” will replace this number on the kiosk.',
            },
        },
        proteinContent: {
            type: 'int',
            displayName: 'Protein',
            min: 0,
            isNullable: true,
        },
        posProteinContent: {
            type: 'int',
            displayName: 'POS Protein',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default protein content. The field “Protein” will replace this number on the kiosk.',
            },
        },
        fatContent: {
            type: 'float',
            displayName: 'Fat',
            min: 0,
            isNullable: true,
        },
        posFatContent: {
            type: 'float',
            displayName: 'POS Fat',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default fat content. The field “Fat” will replace this number on the kiosk.',
            },
        },
        carbohydrateContent: {
            type: 'int',
            displayName: 'Carbohydrates',
            min: 0,
            isNullable: true,
        },
        posCarbohydrateContent: {
            type: 'int',
            displayName: 'POS Carbohydrates',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default carbohydrate content. The field “Carbohydrates” will replace this number on the kiosk.',
            },
        },
        sugarContent: {
            type: 'int',
            displayName: 'Sugar',
            min: 0,
            isNullable: true,
        },
        posSugarContent: {
            type: 'int',
            displayName: 'POS Sugar',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default sugar content. The field “Sugar” will replace this number on the kiosk.',
            },
        },
    },
};
//# sourceMappingURL=nutrition_info_schema.js.map